import {Component} from '@angular/core';

@Component({
  selector: 'goto-ico',
  templateUrl: './goto-ico.component.html'
})
export class GotoIcoComponent {
}
